<mat-form-field
	[appearance]="appearance()"
	[floatLabel]="floatLabel()"
	class="jepto-ui-input-field"
	subscriptSizing="dynamic"
	[attr.data-testid]="testId() || null"
	[class.jepto-ui-input-field--labeled]="!!label()"
	[class.jepto-ui-input-field--readonly]="readonly()"
	[class.jepto-ui-input-field--semibold-value]="semiboldValue()"
	[class.has-error]="showError()"
	[class.focused]="focused"
	[class.disabled]="disabled()"
	[class.readonly]="readonly()"
	[class.jepto-ui-input-field--fill-transparent-bg]="
		useTransparentFillBackground()
	"
	[class.jepto-ui-input-field--application-fill]="useApplicationFill()"
	[class.jepto-ui-input-field--application-fill-dark]="
		useApplicationFill() && applicationFillDark()
	"
	[style.--jepto-ui-input-fill-background]="resolvedApplicationFillBackground()"
	[style.--jepto-ui-input-fill-underline-color]="applicationFillUnderlineColor() ?? null"
>
	<!-- Label -->
	<mat-label *ngIf="label()">
		{{ label() }}
	</mat-label>

	<!-- Prefix Icon -->
	<mat-icon
		matIconPrefix
		*ngIf="hasPrefix()"
		class="prefix-icon material-symbols-outlined"
		(click)="onPrefixIconClick()"
	>
		{{ prefixIcon() }}
	</mat-icon>

	<!-- Input Element -->
	<input
		#nativeInput
		matInput
		[id]="resolvedInputId()"
		[type]="type()"
		[placeholder]="placeholder()"
		[value]="value"
		[disabled]="disabled()"
		[readonly]="readonly()"
		[required]="required()"
		[attr.maxlength]="maxLength() ?? null"
		[attr.minlength]="minLength() ?? null"
		[autocomplete]="autocomplete()"
		[attr.name]="fieldName() ?? null"
		[spellcheck]="spellcheck()"
		[tabindex]="tabIndex()"
		(input)="onInputChange($event)"
		(focus)="onInputFocus()"
		(blur)="onInputBlur()"
		(keypress)="onKeyPress($event)"
		[attr.title]="null"
		class="jepto-input-element"
	/>

	<!-- Suffix Icons -->
	<div matIconSuffix *ngIf="hasSuffix()" class="suffix-container">
		<!-- Clear Button -->
		<button
			mat-icon-button
			*ngIf="showClear()"
			type="button"
			class="clear-button"
			tabindex="-1"
			(click)="onClearClick()"
			aria-label="Clear input"
		>
			<mat-icon class="material-symbols-outlined">clear</mat-icon>
		</button>

		<!-- Custom Suffix Icon -->
		<mat-icon
			*ngIf="suffixIcon()"
			class="suffix-icon material-symbols-outlined"
			(click)="onSuffixIconClick()"
		>
			{{ suffixIcon() }}
		</mat-icon>
	</div>

	<!-- Hint Text -->
	<mat-hint *ngIf="showHint()">{{ hint() }}</mat-hint>

	<!-- Error Message -->
	<mat-error *ngIf="showError()">{{ errorMessage() }}</mat-error>
</mat-form-field>
